export default {"src":"/_next/static/media/check-purple.a152fc7f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};